type SvgProps = React.SVGProps<SVGSVGElement>;
export const MagicWand = (props: SvgProps) => (
  <svg
    {...props}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_558_5498)">
      <path
        d="M7.0405 2.793L0.450004 9.3845C0.179214 9.67486 0.0317252 10.059 0.0386226 10.456C0.04552 10.853 0.206265 11.2318 0.486979 11.5125C0.767693 11.7933 1.14645 11.9541 1.54342 11.9611C1.9404 11.9681 2.32458 11.8207 2.615 11.55L9.207 4.9595L7.0405 2.793ZM7.793 4.9595L6.5 6.2525L5.75 5.5L7.043 4.207L7.793 4.9595ZM1.908 10.844C1.80693 10.9403 1.67264 10.9941 1.533 10.9941C1.39336 10.9941 1.25908 10.9403 1.158 10.844C1.05871 10.7445 1.00295 10.6096 1.00295 10.469C1.00295 10.3284 1.05871 10.1935 1.158 10.094L5.0425 6.209L5.795 6.9615L1.908 10.844ZM10.6665 7.314L12 7.981L10.6665 8.65L10 9.981L9.3335 8.65L8 7.981L9.3335 7.314L10 5.981L10.6665 7.314ZM3.3335 2.6665L2 2L3.3335 1.3335L4 0L4.6665 1.3335L6 2L4.6665 2.6665L4 4L3.3335 2.6665ZM9.6665 2.3335L8.5 1.75L9.6665 1.1665L10.25 0L10.8335 1.1665L12 1.75L10.8335 2.3335L10.25 3.5L9.6665 2.3335Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_558_5498">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
